<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" style="justify-content: center" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-row align="center" justify="center">
              <v-card class="mx-auto" width="400">
                <v-row justify="center">
                  <v-img
                    align="center"
                    justify="center"
                    class="mt-12"
                    aspect-ratio="5"
                    :transition="false"
                    contain
                    :src="
                      require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
                    "
                  />
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row align="center" justify="center">
                      <v-card class="elevation-0" width="400">
                        <v-card-text
                          class="mt-0 pt-0"
                          style="word-break: normal; text-align: center"
                        >
                          {{
                            $t("general.resetPassword.resetYourPassword")
                          }}</v-card-text
                        >
                      </v-card>
                    </v-row>
                  </v-col>
                </v-row>
                <v-form
                  @keydown.native.enter="register"
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        :label="$t('general.resetPassword.enterPassword')"
                        type="password"
                        :rules="passwordlRule"
                        v-model="input.password"
                        :name="Math.random()"
                        required
                      />
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                      <v-text-field
                        class="mx-6"
                        color="primary"
                        :label="$t('general.resetPassword.retypePassword')"
                        type="password"
                        :rules="passwordlRule"
                        v-model="input.confirmPassword"
                        :name="Math.random()"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-col cols="12">
                      <v-btn
                        class="float-right"
                        @click="reset"
                        color="primary"
                        dark
                        text
                        >{{ $t("general.resetPassword.resetPassword") }}</v-btn
                      >
                    </v-col>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <powered-by-sentinel :is-navbar="false" />
  </v-app>
</template>

<script>
import { AUTH_REGISTER } from "@/store/actions/auth.js";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import cookie from "@/utils/cookie";
import snackbar from "@/utils/snackbar";
import api from "@/utils/api";
import { mapGetters } from "vuex";
import PoweredBySentinel from "@/components/banners/PoweredBySentinel.vue";

export default {
  components: { PoweredBySentinel },
  data() {
    return {
      passwordlRule: [],
      valid: true,
      isDirty: false,
      errorText: "",
      input: {
        password: "",
        confirmPassword: "",
      },
    };
  },
  created() {
    this.setInitailData();
    !!cookie.getCookie("user-token") && cookie.deleteCookie("user-token");
    this.getTokenValidity();
  },
  computed: {
    ...mapGetters(["getMe", "getTheme"]),
    getResetSuccessText() {
      return this.$t(
        "general.resetPassword.anEmailWasSentToWithInstructionsToRecoverYourPassword",
        { email: this.resetForm.email }
      );
    },
  },
  methods: {
    setInitailData() {
      this.passwordlRule = [
        (v) => !!v || this.$t("general.resetPassword.passwordIsRequired"),
        (v) =>
          v.length >= 8 ||
          this.$t("general.resetPassword.passwordMustBeGraterThan8Characters"),
      ];
    },
    handleAlreadyLoggedIn() {
      cookie.deleteCookie("user-token");
    },

    getTokenValidity() {
      //false parameter is here for disabling error handling
      api
        .getResetTokenValidity(this.$route.params.uuid, false)
        .then((resp) => {
          return;
        })
        .catch((err) => {
          snackbar.error(
            this.$t("utils.snackbar.error.resetPasswordTokenIsExpired")
          );

          this.$router.push({ name: "login" });
        });
    },

    reset() {
      if (this.$refs.form.validate()) {
        if (this.input.password === this.input.confirmPassword) {
          const { email, password, confirmPassword } = this.input;
          //false parameter is here for disabling error handling
          api
            .resetPassword(this.$route.params.uuid, password, false)
            .then(() => {
              snackbar.success(
                this.$t(
                  "utils.snackbar.success.passwordHasBeenSuccessfullyChanged"
                )
              );
              this.$router.push({ name: "login" });
            })
            .catch((err) => {
              snackbar.error(
                this.$t(
                  "utils.snackbar.error.anErrorHasOccuredPleaseTryAgainLater"
                )
              );
              this.$router.push({ name: "login" });
            });
        } else {
          snackbar.error(
            this.$t("utils.snackbar.error.thosePasswordsDoNotMatchTryAgain")
          );
        }
      }
    },
  },
};
</script>
<style scoped></style>
